import React from 'react';
import { Box, IconButton, InputAdornment, Stack, TextField } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { useAppTFunction } from '@retail/app/i18n';
import { OrgUnitType } from '@retail/mgpris/config-types';
import { OrgUnitTypeFilter } from './OrgUnitTypeFilter';

interface Props {
  query: string;
  setQuery: (val: string) => void;
  inputRef: React.RefObject<HTMLInputElement>;
  typeOptions: OrgUnitType[];
  selectedTypes: OrgUnitType[];
  toggleType: (orgUnitType: OrgUnitType) => void;
  clearTypes: () => void;
}

export const OrgUnitAssortmentSearchHeader: React.FC<Props> = ({
  query,
  setQuery,
  inputRef,
  typeOptions,
  selectedTypes,
  toggleType,
  clearTypes,
}) => {
  const t = useAppTFunction();

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 2,
        bgcolor: 'background.paper',
        p: 2,
        pt: 1.5,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Stack gap={1.5}>
        <TextField
          size="small"
          inputRef={inputRef}
          fullWidth
          placeholder={t('products.search.openSearch.search')}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  {query ? (
                    <IconButton
                      size="small"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => setQuery('')}
                    >
                      <Clear fontSize="small" />
                    </IconButton>
                  ) : null}
                </InputAdornment>
              ),
            },
          }}
        />
        {typeOptions.length > 1 && (
          <OrgUnitTypeFilter
            options={typeOptions}
            selected={selectedTypes}
            toggle={toggleType}
            clear={clearTypes}
          />
        )}
      </Stack>
    </Box>
  );
};
